exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Photo {\n  -webkit-user-drag: none;\n  user-select: none;\n  -webkit-user-select: none;\n  -webkit-touch-callout: none; }\n  .Photo--hasBorder {\n    border: 5px solid #F57C00; }\n  .Photo--loading {\n    display: none; }\n", ""]);

